import * as Fetch from '@/helpers/fetch'

export const verifyDopa = async (
  token: string,
  requestBody: any,
): Promise<Fetch.HttpResponse> => {
  const url = `${process.env.VUE_APP_SERVICE_URL}/v1/dopa/verifications`
  const body = requestBody

  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  }
  try {
    const result = await Fetch.post(url, options)

    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}
